document.addEventListener('DOMContentLoaded', function() {
  const tabContainers = document.querySelectorAll('.section-image-text-promo .tabs-container');
  
  tabContainers.forEach(function(container) {
    const tabs = container.querySelectorAll('.tab-title');
    const blocks = container.querySelectorAll('.card-block');
    
    function showBlocksForTab(activeTabName) {
      blocks.forEach(function(block) {
        const blockTabName = block.getAttribute('data-tab-content');
        if (blockTabName === activeTabName) {
          block.classList.add('active');
        } else {
          block.classList.remove('active');
        }
      });
    }
    
    if (tabs.length > 0) {
      const firstTabName = tabs[0].getAttribute('data-tab');
      showBlocksForTab(firstTabName);
    }
    
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        
        tabs.forEach(function(t) {
          t.classList.remove('active');
        });
        
        tab.classList.add('active');
        
        const activeTabName = tab.getAttribute('data-tab');
        showBlocksForTab(activeTabName);
      });
    });
  });
});
